import pDebounce from 'p-debounce';
import { useState } from 'react';

const useLoadSriOptions = (sriLoadOptions) => {
  const [currentAbortController, setCurrentAbortController] = useState(null);
  const debouncedRetFn = pDebounce((inputValue) => {
    const doSearch = async (query) => {
      if (!sriLoadOptions) return null;
      try {
        if (currentAbortController) currentAbortController.abort();
        const newAbortController = new AbortController();
        setCurrentAbortController(newAbortController);

        const apiSearch = await sriLoadOptions.sriClient.getRaw(
          sriLoadOptions.href,
          {
            ...sriLoadOptions.parameters,
            [sriLoadOptions.searchParameter || 'q']: query,
          },
          { cancel: newAbortController.signal }
        );
        return apiSearch.results;
      } catch (error) {
        if (error.name && error.name === 'AbortError') {
          console.log(
            '[use search api hook] A new request was send before the response of another request was received. The previous request is canceled'
          );
          return undefined;
        }
        console.error(error);
        return undefined;
      }
    };
    return doSearch(inputValue);
  }, 350);

  if (!sriLoadOptions) {
    return null;
  }
  return debouncedRetFn;
};

export default useLoadSriOptions;
